<h1>#genuary7 @jeantonique</h1>

<p>
  Using the fantastic palette from You by Jean Tonique.
  Lava lamp inspired as well.
  </p>

<img src="../genuary/img/07/1.png" alt="genuary7 by Pandelune" />
<p></p>
<img src="../genuary/img/07/2.png" alt="genuary7 by Pandelune" />
<p></p>
<img src="../genuary/img/07/3.png" alt="genuary7 by Pandelune" />
<p></p>
<img src="../genuary/img/07/4.png" alt="genuary7 by Pandelune" />
<p></p>
<img src="../genuary/img/07/5.png" alt="genuary7 by Pandelune" />

